:host {
    display: block;
}

.ux-iws-gated-content {
    position: relative;

    &__content {
        max-height: 500px;
        overflow: hidden;
        pointer-events: none;

        &.ux-iws-gated-content__content--visible {
            max-height: 100%;
            pointer-events: auto;
        }
    }

    &__overlay {
        margin: 0 auto;
        padding: 30px 0 50px;
        width: 100%;
        background-color: $color-blue-6;
        z-index: 999;
        position: relative;

        @media only screen and (min-width: $tablet) {
            padding-bottom: 60px;
        }

        @media only screen and (min-width: $desktop-s) {
            padding-bottom: 80px;
        }

        &::before {
            content: "";
            left: 0;
            top: 0;
            transform: translateY(-100%);
            width: 100%;
            height: 120px;
            background: linear-gradient(
                180deg,
                rgba(239, 240, 244, 0) 0%,
                $color-blue-6 100%
            );
            position: absolute;
        }
    }

    &__button {
        display: flex;
        justify-content: center;
    }
}
